/**
 * Cookieのkey
 */
export const COOKIE_KEYS = {
  TOKEN: "token",
  NEXT_LOCALE: "NEXT_LOCALE",
  IW_VIEW: "iw-view",
  SA_VIEW: "sa-view",
  UA_VIEW: "ua-view",
  AA_VIEW: "aa-view",
  LAST_WORKSPACE_ID: "last_workspace_id",
  LOGIN_REDIRECT_PATH: "login_redirect_path",
  LOGOUT_REASON: "logout_reason",
  STRIPE_CHECKOUT_WORKSPACE_ID: "stripe_checkout_workspace_id",
  STRIPE_CHECKOUT_CONTRACT_ID: "stripe_checkout_contract_id",
  SIDEBAR_STATE: "sidebar:state",
  SIDEBAR_LAYOUT: "sidebar:layout",
  INBOX_LAYOUT: "inbox:layout",
} as const;
